import React from 'react';
import { Row,Col } from 'antd';
import Header from './components/Header';
import Footer from './components/Footer';
import NavLeft from './components/NavLeft';
import './style/common.less';
import './style/style.css';


export default class Admin extends React.Component{

    render(){
        return(
            <Row className="container">
                <Col sm={4} xs={12}>
                    <NavLeft/>
                </Col>
                <Col sm={20} xs={12} className="main">
                    <Header/>
                    <Row className="content">
                        {this.props.children}
                    </Row>
                    <Footer/>
                </Col>
            </Row>
        );
    }
}


// WEBPACK FOOTER //
// ./src/admin.js